import { Component, EventEmitter, Input, Output } from '@angular/core';
import { animate, style, transition, trigger } from '@angular/animations';

@Component({
    selector: 'mycampapp-waiting-indicator',
    templateUrl: './waiting-indicator.component.html',
    styleUrls: ['./waiting-indicator.component.less'],
})
export class WaitingIndicatorComponent
{
    static animations = [
        trigger('fadeInOut', [
            transition('void => *', [
                style({opacity: 1}),
            ]),
            transition('* => void', [
                animate(200, style({opacity: 0}))
            ])
        ])
    ];

    static animations_no_fade = [
        trigger('fadeInOut', [
            transition('void => *', [
                style({opacity: 1}),
            ]),
            transition('* => void', [
                animate(0, style({opacity: 0}))
            ])
        ])
    ];

    showError = false;

    @Input() backgroundColor = 'transparent';
    @Input() color: string | undefined = undefined;
    @Input() fontSize = '16px';
    @Input() iconSize = '80px';
    @Input() text: string | undefined = undefined;
    @Input() percentComplete = -1;

    private _error?: string;
    @Input() set error(value: string | undefined)
    {
        this._error = value;
        this.showError = (this._error != null && this._error.length > 0);
    }

    get error(): string | undefined { return this._error; }

    @Output() okClick = new EventEmitter();


    constructor() { }

    onOkClick(): void
    {
        this.okClick.emit();
    }
}
